import { render, staticRenderFns } from "./bind-fail.vue?vue&type=template&id=6783e8ba&scoped=true&"
import script from "./bind-fail.vue?vue&type=script&lang=js&"
export * from "./bind-fail.vue?vue&type=script&lang=js&"
import style0 from "./bind-fail.vue?vue&type=style&index=0&id=6783e8ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6783e8ba",
  null
  
)

export default component.exports